import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PreChat } from '../../../models/PreChat';
import { Code } from '../../../models/Code';
import { AdminService } from '../../../services/Admin.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgForm } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pre-chat',
  templateUrl: './pre-chat.component.html',
  styleUrls: ['./pre-chat.component.scss']
})
export class PreChatComponent implements OnInit {
  public preChatData: PreChat = new PreChat();
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public successMsg: string;
  public errorMsg: string;
  public actionUrl: string;
  constructor(private adminSvc: AdminService,
    private route: ActivatedRoute) {
      this.route.queryParams.subscribe( params => {
        this.actionUrl = params['endpoint'];
      });

      console.log(this.actionUrl);
     }

  ngOnInit() {
    this.preChatData.SubjectList = [];
    this.preChatData.ContractRegList = [];
    this.getChatDetails();
  }

  async ngAfterViewInit() {
    // this.initializeLiveChartScript();
    // this.loadLiveChartScript();
    // await this.loadScriptWithReturn('https://c.la4-c1cs-dfw.salesforceliveagent.com/content/g/js/42.0/deployment.js');
    // await this.loadScriptWithReturn('https://code.jquery.com/jquery-1.7.1.min.js');
    // this.loadLiveChartScript();
  }

  onSubmit(event): void {
    event.target.submit();
  }

  private initializeLiveChartScript() {
    debugger;
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.innerHTML = 'initChat();';
    document.body.appendChild(scriptTag);
  }

  getChatDetails() {
    this.adminSvc.getLiveChatDetails().subscribe(data => {
          this.showFailConfirmation = false;
          this.showSuccessConfirmation = false;
          this.successMsg = null;
          this.preChatData = data;
      },
      err => {
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.successMsg = null;
          this.errorMsg = err;
      });
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  handleRegNumChange(frmPreChat: NgForm, event) {
    const contractNum = this.preChatData.ContractRegList.filter(item => item.Name.trim() === event.Name.trim())[0].ID.trim();
    frmPreChat.controls['preChatData.ContractNumber'].setValue(contractNum);
  }

  handleContractNumChange(frmPreChat: NgForm, event) {
    const regNum = this.preChatData.ContractRegList.filter(item => item.ID.trim() === event.ID.trim())[0].Name.trim();
    frmPreChat.controls['preChatData.RegistrationNumber'].setValue(regNum);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/pre-chat/pre-chat.component.ts